import BenchlingConfig from 'BenchlingConfig';

export function areRegistryErrorBadgesEnabled(): boolean {
  return BenchlingConfig.REGISTRY_ENABLE_ASYNC_VALIDATION_ERROR_BADGES;
}
